
import  { useState } from "react";
// import { nanoid } from 'nanoid';
import Button from "../UI/Button";
import StyledForm from "./Form.Module";




function Form() {
    
    const [jumlah, setJumlah] = useState('');
    const [select, setSelect] = useState('');
    const [selecttwo, setSelectTwo] = useState('');
   
    

    // const [addFormData, setAddFormData] = useState({
    //     provinsi: '',
    //     status:'',
    //     jumlah:''
    // })
  
    // const handleAddForm = (event) => {
    //     event.preventDefault();


    //     const fieldName = event.target.getAttribute('name');
    //     const fieldValue = event.target.value;


    //     const newFormData = { ... addFormData};
    //     newFormData[fieldName] = fieldValue;

    //     setAddFormData(newFormData);

    // };

    // const handleSubmit = (event) => {
    //     event.preventDefault();


    //     const newContact = {
    //            id : nanoid(),
    //            provinsi : addFormData.provinsi,
    //            status : addFormData.status,
    //            jumlah : addFormData.jumlah,
    //     };

    //     const newContacts = [...contacts, newContact];
    //     setContacts(newContacts); 

    // };


    //video kakak aufa

    //handleJumlah
    //setiap data yang diinput maka ditangkap dan seterusnya ...
    // function handleJumlah(e){
    //     setJumlah(e.target.value);
    // }



    function handleSubmit(e){
        e.preventDefault();
        console.log("Cegah");

        
    }

    return(

        <StyledForm>
             <div  className="container">
            <section  className="form">
              
                <div   className="form__left">
                    <img   className="form__image" src="https://media.discordapp.net/attachments/894919708938223657/961641885640818758/AddCovidForm.jpg" alt=""/>
                </div>


                <div  className="form__right">
                    <h1>Form Covid</h1>
                    {/* <form  className={styles.Form__add}  >
                        
                        <div className={styles.Form__control}>
                            <p htmlFor="title">Title</p>
                            <input className={styles.Form__inputone} type="text" 
                            />
  
                        </div>
                        
                        <div className={styles.Form__control}>
                            <p>Year</p>
                            <input className={styles.Form__inputtwo} type="date" 
                            />
  
                        </div>


                        <div className={styles.Form__control}>
                            <p>Link Gambar</p>
                            <input className={styles.Form__inputhree} type="text"   
                            />  
                        </div>

                        <div className={styles.Form__control}>
                            <p>Select Movie</p>
                            <select name="select" id="" >
                                <option value=""></option>
                                <option value="Horor">Horor</option>
                                <option value="Romance">Romance</option>
                                <option value="Survival">Survival</option>
                            </select>

                            
                        </div>

                        <button className={styles.Form__button} >Submit</button>
                    </form> */}



            {/* <h4>{select}</h4>
              <h4>{selecttwo}</h4>
              <h4>{jumlah}</h4> */}

        <form onSubmit={handleSubmit}>
            <div className="form__group">
                <label htmlFor="provinsi"  className="form__label">Provinsi</label>
                {/* onChange={handleAddForm} */}


                    <select name="provinsi" id="" placeholder="Input Data Provinsi"  className="form__select" >
                        <option value=""></option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Banda Aceh</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Padang</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Medan</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Palembang</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Bandar Lampung</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Pekanbaru</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Tanjung Pinang</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Jambi</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Pangkal Pinang</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Bengkulu</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Jakarta</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Serang</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Bandung</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Semarang</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Surabaya</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Yogyakarta</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Denpasar</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Mataram</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Kupang</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Pontianak</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Banjarmasin</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Palangkaraya</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Samarinda</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Tanjung Selor</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Mamuju</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Kendari</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Makassar</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Palu</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Manado</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Gorontalo</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Ambon</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Sofifi</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Jayapura</option>
                        <option  value={select}  onChange={(e) => { setSelect(e.target.value)}}>Manokwari</option>


                    </select>              
            
            </div>

            <div  className="form__group">
                <label htmlFor="status"   className="form__label">Status</label>
                {/* onChange={handleAddForm} */}


                    <select name="status" id="" placeholder="Status Kasus"   className="form__select" >
                        <option value=""></option>
                        <option value={selecttwo}  onChange={(e) => { setSelectTwo(e.target.value)}} >Positif</option>
                        <option value={selecttwo}  onChange={(e) => { setSelectTwo(e.target.value)}} >Negatif</option>
                        <option value={selecttwo}  onChange={(e) => { setSelectTwo(e.target.value)}} >Sembuh</option>
                        <option value={selecttwo}  onChange={(e) => { setSelectTwo(e.target.value)}} >Meninggal</option>

                    </select>              
            
            </div>

            
            <div className="form__group">
              <label htmlFor="jumlah"  className="form__label">Jumlah</label>
              {/* onChange={handleAddForm}   name="jumlah" */}



              <input id="jumlah" placeholder="Input Jumlah Satu Persatu"  className="form__input" type="text" value={jumlah}  onChange={(e) => { setJumlah(e.target.value)}} />
            
            </div>
            <div>
              {/* <button className={styles.form__button}>Submit</button> */}
              <Button variant="submit" full>Submit</Button>

             
            </div>
          </form>

                </div>
            </section>
        </div>


        </StyledForm>
       
    );
  }




export default Form;